
import { defineComponent, ref } from 'vue'
import TeamMonthlyCalendar from '@/components/calendars/team-monthly.vue'
import TeamsDropdown from '@/components/teams-dropdown.vue'

export default defineComponent({
  components: { TeamsDropdown, TeamMonthlyCalendar },
  setup() {
    const monthlyCalendar = ref<{ exportCsv?: () => void } | null>(null)

    function exportCsv() {
      monthlyCalendar.value?.exportCsv?.()
    }

    return { monthlyCalendar, exportCsv }
  }
})
